<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
  <form [formGroup]="formUpload" autocomplete="off" class="upload-form" style="margin-top: 10px;">

    <mat-form-field appearance="outline" class="full">
      <mat-label>Name</mat-label>
      <input
        matInput
        required
        autocomplete="off"
        placeholder="File name"
        formControlName="AttachmentName" readonly/>
    </mat-form-field>

    <!-- hidden file input -->
    <input
      #ebbFileInput
      id="dialog-file-upload-input"
      type="file"
      [accept]="data?.isImage ? 'image/png,image/jpeg' : '.pdf,.docx,image/png,image/jpeg'"
      hidden
      (click)="ebbFileInput.value = null"
      (change)="ebbFileInputChange($event)" />

    <!-- buttons row -->
    <div class="actions-row">
      <button
        mat-flat-button
        color="accent"
        type="button"
        (click)="ebbFileInput.click()">
        BROWSE FOR FILE
      </button>

      @if (showRotateImage) {
        <button
          mat-flat-button
          color="accent"
          type="button"
          (click)="rotateImageOrientation()">
          <mat-icon>rotate_right</mat-icon>
          ROTATE {{ rotateDegree }}&deg;
        </button>
      }
    </div>

    <!-- filename / error -->
    <div class="file-status">
      @if (!fileError) {
        <p class="mat-body-2">{{ displayFileName }}</p>
      } @else {
        <p class="mat-error">
          <mat-icon inline>warning</mat-icon>
          {{ displayFileName }}
        </p>
      }
    </div>

    <!-- helper or preview -->
    <div class="preview-area">
      @if (!displayFileUrl) {
        <div class="helper-text">
          <p>Only the following file types can be uploaded:</p>
          <ul>
            @if (!data.isImage) {
              <li>Adobe PDF</li>
              <li>Microsoft Word DOCX</li>
            }
            <li>Image JPG</li>
            <li>Image PNG</li>
          </ul>
          <p>The maximum file size is {{ fileMaxSize }}MB.</p>
        </div>
      } @else {
        <div class="preview-box" [class.image]="data.isImage" [class.doc]="!data.isImage">
          <img [src]="displayFileUrl" alt="uploaded file" />
        </div>
      }
    </div>

  </form>
</div>

<div mat-dialog-actions class="dialog-actions" style="margin-top: 9px !important; float: right !important;">
  <button mat-button type="button" (click)="onClickCancel()">CANCEL</button>
  <button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="data"
    [disabled]="disableFileSave"
    type="button">
    SAVE
  </button>
</div>

